"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = property;
var _deepGet = _interopRequireDefault(require("./_deepGet.js"));
var _toPath = _interopRequireDefault(require("./_toPath.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// Creates a function that, when passed an object, will traverse that object’s
// properties down the given `path`, specified as an array of keys or indices.
function property(path) {
  path = (0, _toPath.default)(path);
  return function (obj) {
    return (0, _deepGet.default)(obj, path);
  };
}